export default __webpack_public_path__ + "static/media/Snd_S_Starts.2aefc290.mp3";